import { useState } from "react";
import { useLocalization } from "@fluent/react";
import { LoadingShim } from "@narmi/design_system";
import { useDashboardLayoutRedesignEnabled } from "byzantine/src/dbbl/businessLogic/modules/dashboard/hooks";
import SectionCard from "../SectionCard";
import SignedUrlIframe from "../SignedUrlIframe";
import { useUserFeatures } from "../contexts/UserFeaturesContext";
import useIsChartCardEnabled from "./ChartCard.hooks";
import BorderCard from "../BorderCard";
import PfmContainer from "./Pfm/PfmContainer";

type ChartCardProps = {
  borderCard?: boolean;
};

const ChartCard = ({ borderCard }: ChartCardProps) => {
  const { l10n } = useLocalization();
  const features = useUserFeatures();
  const isChartCardEnabled = useIsChartCardEnabled();
  const isDashboardLayoutRedesignEnabled = useDashboardLayoutRedesignEnabled();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState();

  const { mx_mini_widget_endpoint: mxMiniWidgetEndpoint } = features;
  const endpoint =
    mxMiniWidgetEndpoint ?? "signed_urls/mx/urls/net_worth_widget";

  if (
    isChartCardEnabled &&
    isDashboardLayoutRedesignEnabled &&
    endpoint === "signed_urls/mx/urls/spending_widget"
  ) {
    return <PfmContainer />;
  }

  const titleKey =
    endpoint === "signed_urls/mx/urls/spending_widget"
      ? "heading-spending"
      : "heading-net-worth";

  if (error || !isChartCardEnabled) return null;
  const title = l10n.getString(titleKey);

  const content = (
    <LoadingShim isLoading={loading}>
      <div style={{ minHeight: 200 }}>
        {!borderCard && <SectionCard.Title text={title} />}
        <SignedUrlIframe
          endpoint={endpoint}
          height="550px"
          setLoading={setLoading}
          setError={setError}
        />
      </div>
    </LoadingShim>
  );

  return borderCard ? (
    <BorderCard title={title}>{content}</BorderCard>
  ) : (
    <SectionCard classNames="dashboard-section-card">{content}</SectionCard>
  );
};

export default ChartCard;
